import PageEditor from '../components/page-editor'

function PageEditorPage() {
  return <PageEditor />
}

export default PageEditorPage
